import en from './en'
import fr from './fr'
import ar from './ar'

export default {
  en,
  fr,
  ar
}
